import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  SelectChangeEvent,
  TextField,
} from "@mui/material";
import { useSchemes } from "../../../../contexts/SchemesContext";
import { useLogger } from "../../../../contexts/LoggerContext";
import { KickoffReturnPlaySelection } from "../../../../types/LogTypes";

export const KickOffReturnPlaySelection = () => {
  const { kickOffReturnPersonnel, kickOffReturnPlays } = useSchemes();
  const { setCurrentPlayCall } = useLogger();

  const [selectedPersonnel, setSelectedPersonnel] = useState<number | null>(
    null
  );
  const [selectedPlay, setSelectedPlay] = useState<number | null>(null);

  const handlePersonnelChange = (event: SelectChangeEvent<number | "">) => {
    setSelectedPersonnel(event.target.value as number);
  };

  const handlePlayChange = (event: SelectChangeEvent<number | "">) => {
    setSelectedPlay(event.target.value as number);
  };

  useEffect(() => {
    const playCall: KickoffReturnPlaySelection = {
      personnel_group_id: selectedPersonnel,
      play_id: selectedPlay,
    };
    setCurrentPlayCall(playCall);
  }, [selectedPersonnel, selectedPlay, setCurrentPlayCall]);
  return (
    <Paper elevation={3} sx={{ p: 1 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minWidth: 800,
        }}
      >
        <Grid container>
          {/* Personnel Group Selection */}
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <FormControl fullWidth sx={{ mb: 1, minWidth: 250 }}>
                <InputLabel id="personnel-group-label">
                  Personnel Group
                </InputLabel>
                <Select
                  labelId="personnel-group-label"
                  id="personnel-group"
                  value={selectedPersonnel || ""}
                  label="Personnel Group"
                  onChange={handlePersonnelChange}
                >
                  {kickOffReturnPersonnel.map((group) => (
                    <MenuItem key={group.id} value={group.id}>
                      {group.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Grid>

          {/* Play Selection */}
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <FormControl fullWidth sx={{ mb: 1, minWidth: 250 }}>
                <InputLabel id="play-label">Play</InputLabel>
                <Select
                  labelId="play-label"
                  id="play"
                  value={selectedPlay || ""}
                  label="Play"
                  onChange={handlePlayChange}
                >
                  {kickOffReturnPlays.map((play) => (
                    <MenuItem key={play.id} value={play.id}>
                      {play.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
};
